import React from 'react'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'

const GET_LENDERS_FOR_VERTICAL = gql`
  query GET_LENDERS_FOR_VERTICAL($vertical: String!, $loanPurpose: String) {
    getLendersForVertical(vertical: $vertical, loanPurpose: $loanPurpose) {
      id
    }
  }
  `,

  /**
   * Component used to dynamically pull the lender count from verticals to be displayed in marketing text.
   * @param {String} vertical - specific vertical to query lenders from
   * @param {String} loanPurpose - you can also call this query with a second variable
   * named 'loanPurpose' if you were to want to filter results further (e.g., some personal loan lenders do not do home improvement loans)
   * @param {String} startText - clause before the count is displayed (e.g., if we wanted to display
   * 'Rates from up to <count> lenders, then the startText would be 'Rates from up to')
   * @param {String} endText - clause after the count is displayed
   * @param {String} defaultText - fallback text to be returned if the query fails
   * @returns {String} - Currently a Text component interpolated with the query result and props. Could eventually
   * pass the component to be returned as a prop.
   */
  LendersText = props =>
    <Query
      query={GET_LENDERS_FOR_VERTICAL}
      variables={{
        vertical: props.vertical,
        loanPurpose: props.loanPurpose
      }}
    >
      {result => composeLendersStringFromPropsAndQuery(result, props)}
    </Query>,

  // We're omitting loading state since this will be server-side rendered
  composeLendersStringFromPropsAndQuery = (queryResult, props) => {
    const {error, data} = queryResult,
      {startText, endText, defaultText} = props,
      formattedStartText = startText.trim(),
      formattedEndText = endText.trim()

    if (error) {
      return defaultText
    }

    if (data && data.getLendersForVertical) {
      return `${formattedStartText} ${data.getLendersForVertical.length} ${formattedEndText}`
    }

    return ''
  }

LendersText.propTypes = {
  vertical: PropTypes.oneOf(['refi', 'in_school', 'personal_loans']).isRequired,
  loanPurpose: PropTypes.string,
  startText: PropTypes.string,
  endText: PropTypes.string,
  defaultText: PropTypes.string
}

LendersText.defaultProps = {
  startText: 'Rates from up to',
  endText: 'lenders',
  defaultText: 'Rates from our many lenders',
  loanPurpose: null
}

export {GET_LENDERS_FOR_VERTICAL}
export default LendersText
